export default __webpack_public_path__ + "static/media/Flag_of_Zambia.211ff984.svg";